import { put, call, takeLatest, fork, select } from 'redux-saga/effects'
import RootState from '../root-state'
import { adminUsersActionType, adminUsersActions } from './actions'
import { searchAdminUser, updateAdminUserRole } from '../api'
import { toastActions } from '../toast'

export function* searchAdminUserWorker(
  action: ReturnType<typeof adminUsersActions.searchAdminUserRequest>
) {
  try {
    const state: RootState = yield select()
    const token = state.auth0.auth.idToken
    const response = yield call(searchAdminUser, token, action.payload.email)

    // OpenAPI仕様に従ってresponse.adminUserを抽出
    const adminUserDetail = response.adminUser

    yield put(adminUsersActions.searchAdminUserSuccess(adminUserDetail))
    yield put(
      toastActions.show({
        title: '成功！',
        body: 'ユーザーを検索しました',
      })
    )
  } catch (error) {
    yield put(adminUsersActions.throwError(error))
    yield put(
      toastActions.show({
        type: 'error',
        title: '失敗...',
        body: 'ユーザーの検索に失敗しました',
      })
    )
  }
}

export function* updateAdminUserRoleWorker(
  action: ReturnType<typeof adminUsersActions.updateAdminUserRoleRequest>
) {
  try {
    const { email, roleName } = action.payload.request

    // ロール名を日本語表示用に変換
    const getRoleDisplayName = (role: string): string => {
      switch (role) {
        case 'SBJ_Admin':
        case 'sbj_admin':
          return '管理者'
        case 'SBJ_Shop':
        case 'sbj_shop':
          return '店舗'
        default:
          return role
      }
    }

    const displayRoleName = getRoleDisplayName(roleName)

    // 確認ダイアログを表示
    const confirmed = yield call(() =>
      window.confirm(`${email} の権限を ${displayRoleName} に変更しますか？この操作は取り消すことができません。`)
    )

    if (confirmed) {
      const state: RootState = yield select()
      const token = state.auth0.auth.idToken
      yield call(updateAdminUserRole, token, email, roleName)

      // 更新後に再度ユーザー情報を取得
      const searchResponse = yield call(searchAdminUser, token, email)
      const adminUserDetail = searchResponse.adminUser

      yield put(adminUsersActions.updateAdminUserRoleSuccess(adminUserDetail))
      yield put(
        toastActions.show({
          title: '成功！',
          body: `${email}の権限を更新しました`,
        })
      )
    }
  } catch (error) {
    yield put(adminUsersActions.throwError(error))
    yield put(
      toastActions.show({
        type: 'error',
        title: '失敗...',
        body: `権限の更新に失敗しました`,
      })
    )
  }
}

export function* watchSearchAdminUser() {
  yield takeLatest(adminUsersActionType.SEARCH_ADMIN_USER_REQUEST, searchAdminUserWorker)
}

export function* watchUpdateAdminUserRole() {
  yield takeLatest(adminUsersActionType.UPDATE_ADMIN_USER_ROLE_REQUEST, updateAdminUserRoleWorker)
}

export const adminUsersSagas = [
  fork(watchSearchAdminUser),
  fork(watchUpdateAdminUserRole)
]
